import React, { useEffect } from 'react';
import { useAsyncValue, useSubmit, useActionData, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// Components
import AnimalsForm from '../../../../../components/forms/ActionForms/AnimalsForm';

// Types
import { NewAnimal } from '../../../../../components/display/tables/formTables/AnimalSelectionTable/types';
import { TabValidationStatus } from '../../../../../utils/formValidation';

// Utils
import {
  createFormDataFromValues,
  parseValueFromObjectOfObjects,
} from '../../../../../utils/forms';

// Constants
import { formActionNaming } from '../../../../../components/forms/ActionForms/constants';

// Redux actions
import { openModal } from '../../../../../state/actions/ui/modal';

// Modal IDs
import { modalIds } from '../../../../../components/modals/SuperModal/types';

// Types for action data
interface ActionValidationResult {
  validationFailed?: boolean;
  validationErrors?: Array<{ tab: string; tabKey: string; field: string; message: string }>;
  tabsWithErrors?: TabValidationStatus[];
  validationSummary?: string;
  error?: boolean;
  errorMessage?: string;
}

// Map tab keys to route paths
const TAB_ROUTES: Record<string, string> = {
  'operators-and-vehicles': '../operators-and-vehicles',
  'location': '../location',
  'edition': '../edition',
  'budget-items': '../budget-items',
  'materials': '../materials',
  'machinery': '../machinery',
  'animals': '.',
};

export default function AnimalsFormPage(): JSX.Element {
  const submit = useSubmit();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loaderData = useAsyncValue() as any;
  const actionData = useActionData() as ActionValidationResult | undefined;

  // Handle validation errors when action returns
  useEffect(() => {
    if (actionData?.validationFailed && actionData?.tabsWithErrors) {
      console.log('🔴 [AnimalsFormPage] Mostrando modal de errores de validación');

      dispatch(
        openModal(modalIds.VALIDATION_ERRORS_MODAL, {
          tabsWithErrors: actionData.tabsWithErrors,
          validationSummary: actionData.validationSummary,
          onNavigateToTab: (tabKey: string) => {
            const route = TAB_ROUTES[tabKey] || `../${tabKey}`;
            // Navigate to the tab with state indicating validation should be shown
            navigate(route, { state: { validateOnMount: true } });
          },
        })
      );
    }
  }, [actionData, dispatch, navigate]);

  const onFormSubmit = (values: { [key: string]: NewAnimal }) => {
    const parsedValues = parseValueFromObjectOfObjects(values);
    const animalsFormData = createFormDataFromValues(parsedValues);

    submit(animalsFormData, {
      method: 'POST',
      action: '.',
    });
  };

  return (
    <AnimalsForm
      onFormSubmit={onFormSubmit}
      initialData={loaderData}
      sessionStorageKey={formActionNaming.NEW_ANIMALS_FORM}
    />
  );
}
